// extracted by mini-css-extract-plugin
export default {"modal":"CX-z","addItemButton":"DX-z","plusCircle":"EX-z","branchVisible":"FX-z"};